var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.vtooltip),expression:"vtooltip"}],class:{pointer : _vm.isTooLong}},[_vm._v(" "+_vm._s(_vm.textShort)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }